export const Logo = ({ compact = false, light = false, testId = "app-logo" }) => (
  <div className="flex flex-col items-start leading-none" data-testid={testId}>
    <span
      className={`ff-cabinet text-2xl font-black leading-none tracking-tighter ${light ? "text-white" : "text-foreground"}`}
    >
      Ten<span className="text-[#EE7501]" data-testid={`${testId}-x`}>X</span>
    </span>
    {!compact && (
      <span className={`mt-1 text-[10px] font-semibold uppercase tracking-[0.18em] ${light ? "text-white/65" : "text-muted-foreground"}`}>
        Founder-Investor&nbsp;OS
      </span>
    )}
  </div>
);
